import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { useEnquiry } from "@/components/site/EnquiryProvider";

const links = [
  { label: "Collection", href: "#collection" },
  { label: "Heritage Tours", href: "#service-heritage-tours" },
  { label: "Art Classes", href: "#service-art-classes" },
  { label: "Corporate Workshops", href: "#service-corporate-workshops" },
  { label: "Space Styling", href: "#service-space-styling" },
];

export default function Header() {
  const [scrolled, setScrolled] = useState(false);
  const { openEnquiry } = useEnquiry();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <motion.header
      initial={{ y: -80, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.8, delay: 0.2, ease: [0.16, 1, 0.3, 1] }}
      className={`fixed top-0 inset-x-0 z-50 transition-colors duration-500 ${
        scrolled ? "bg-paper/85 backdrop-blur-xl border-b border-ink-soft/15" : "bg-transparent"
      }`}
      data-testid="site-header"
    >
      <nav className="max-w-screen-2xl mx-auto px-6 md:px-10 h-20 flex items-center justify-between">
        <a href="#top" className="flex items-center gap-3" data-testid="logo-link" data-cursor="Home">
          <img
            src="/logo.png"
            alt="The Art Lounge Nirvana"
            className="h-9 md:h-11 w-auto"
          />
          <span className="hidden sm:block h-8 w-px bg-ink-soft/25" />
          <span className="hidden sm:block font-serif text-lg md:text-xl text-ink tracking-tight leading-none">
            Aparna Banerjee
          </span>
        </a>

        <div className="hidden md:flex items-center gap-6 lg:gap-8">
          {links.map((l) => (
            <a
              key={l.href}
              href={l.href}
              data-testid={`nav-${l.label.toLowerCase().replace(/\s+/g, "-")}`}
              className="relative font-body text-[12px] tracking-[0.15em] uppercase text-ink-soft hover:text-ink transition-colors group whitespace-nowrap"
            >
              {l.label}
              <span className="absolute -bottom-1 left-0 h-px w-0 bg-ochre transition-all duration-300 group-hover:w-full" />
            </a>
          ))}
        </div>

        <button
          onClick={() => openEnquiry(null)}
          data-testid="header-enquire-button"
          data-cursor="Enquire"
          className="border border-ink px-5 py-2.5 font-body text-[11px] tracking-[0.2em] uppercase text-ink transition-colors hover:bg-ink hover:text-paper"
        >
          Enquire
        </button>
      </nav>
    </motion.header>
  );
}
